import React from 'react';
import PropTypes from 'prop-types';
import { ButtonRound } from '@ontruck/orc';

const CloseButton = ({ className, onClick }) => (
  <div className={className}>
    <ButtonRound
      skin="primary"
      size="XS"
      onClick={onClick}
      className={className}
      icon="close"
    />
  </div>
);

CloseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

CloseButton.defaultProps = {
  className: '',
  onClick: () => {},
};

export default CloseButton;
